<template>
    <div
        class="m-checkList__row"
        :class="[{ 'm-checkList__row--active': rowCheckbox }]"
    >
        <ui-checkbox-input
            class="text-primary text-sm"
            :name="`row-${row.id}`"
            v-model="rowCheckbox"
            :label="row.label"
        />
    </div>
</template>

<script>
export default {
    props: {
        row: {
            type: Object,
            required: true
        },
        selectedRows: {
            type: Array,
            default: () => []
        },
        selectRow: {
            type: Function,
            default: () => {}
        }
    },
    computed: {
        rowCheckbox: {
            get() {
                return !!this.selectedRows?.find(row => row?.id === this.row.id)
            },
            set(value) {
                this.selectRow({
                    value,
                    id: this.row.id
                })
            }
        }
    }
}
</script>
